import { z } from '#netzo/shared/utils/zod'

export const fiscalDataSchema = z.object({
  satProductServiceKey: z.string().nullable().optional(),
  satUnitKey: z.string().nullable().optional(),
  satTaxObject: z.string().nullable().optional(),
})
